import './styles.sass';

import React from 'react';
import PropTypes from 'prop-types';

const POST_TYPES = [
  'blog',
  'bluesky',
  'f1000',
  'fbwall',
  'gplus',
  'guideline',
  'linkedin',
  'msm',
  'other',
  'patent',
  'peer_review',
  'pinterest',
  'podcast',
  'policy',
  'qna',
  'rdt',
  'seminar',
  'tweet',
  'video',
  'weibo',
  'wikipedia'
];

const PROFILE_TO_ICON = {
  tw: 'tweet',
  sw: 'weibo',
  fb: 'fbwall',
  bsk: 'bluesky',
  seminar_series: 'seminar'
};

class MentionSourceProfileIcon extends React.Component {
  static propTypes = {
    profileType: PropTypes.oneOf([...POST_TYPES, ...Object.keys(PROFILE_TO_ICON)]).isRequired
  };

  render() {
    const { profileType } = this.props;
    const icon = PROFILE_TO_ICON[profileType] || profileType;

    return <div className={`MentionSourceProfileIcon ${icon}`} aria-hidden="true"></div>;
  }
}

export default MentionSourceProfileIcon;
